import type { SuggestSaveState } from './useClientSuggestion';
import type { SaveState } from '../components/Editor/useAutosave';
import type { ScratchSaveState } from '../components/Scratchpad/useScratchAutosave';

export function shouldWarnBeforeUnload(
  draft: SaveState,
  scratch: ScratchSaveState,
  scratchPending: boolean,
  draftPending: boolean,
): boolean {
  return draft === 'dirty' || draft === 'saving' || draft === 'error' || draft === 'stale'
    || scratch === 'saving' || scratch === 'error' || scratch === 'stale' || scratchPending || draftPending;
}

export function warnBeforeUnload(
  event: Pick<BeforeUnloadEvent, 'preventDefault' | 'returnValue'>,
  shouldWarn: boolean,
): void {
  if (!shouldWarn) return;
  event.preventDefault();
  event.returnValue = '';
}

export function shouldWarnClientBeforeUnload(
  suggestion: SuggestSaveState,
  notesPending: boolean,
): boolean {
  return suggestion === 'dirty' || suggestion === 'saving' || notesPending;
}
